<template>
  <el-card class="product-capacities mb-4" shadow="hover">
    <div slot="header" class="d-flex justify-content-between align-items-center">
      <span class="font-weight-bold title">3. Slot mở bán vé (Capacities)</span>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openCreateDialog">
        Thêm Slot bán vé
      </el-button>
    </div>

    <el-table v-loading="loading" :data="capacityList" border style="width: 100%;">
      <el-table-column prop="id" label="ID" width="100" />
      <el-table-column prop="slot_date" label="Ngày / Slot (Slot Date)">
        <template slot-scope="scope">
          <i class="el-icon-time mr-1" />
          {{ formatDate(scope.row.slot_date) }}
        </template>
      </el-table-column>
      <el-table-column prop="total_capacity" label="Tổng sức chứa (Total Capacity)">
        <template slot-scope="scope">
          <el-tag type="info">{{ scope.row.total_capacity }} vé</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Thao tác" width="100" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #F56C6C;"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          >
            Xóa
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Dialog Thêm mới Slot mở bán vé -->
    <el-dialog
      title="Thêm Slot Mở Bán Vé"
      :visible.sync="dialogVisible"
      width="480px"
      append-to-body
    >
      <el-form ref="form" v-loading="submitting" :model="form" :rules="rules" label-width="160px">
        <el-form-item label="Ngày mở bán (Slot)" prop="slot_date">
          <el-date-picker
            v-model="form.slot_date"
            type="datetime"
            placeholder="Chọn ngày và giờ"
            value-format="yyyy-MM-ddTHH:mm:ss.sssZ"
            style="width: 100%;"
          />
        </el-form-item>

        <el-form-item label="Tổng sức chứa" prop="total_capacity">
          <el-input-number
            v-model="form.total_capacity"
            :min="1"
            style="width: 100%;"
            placeholder="Nhập số lượng vé"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Hủy</el-button>
        <el-button type="primary" :loading="submitting" @click="handleCreate">Thêm mới</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { getCapacities, createCapacity, deleteCapacity } from '@/services/product'

export default {
  name: 'ProductCapacities',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      submitting: false,
      dialogVisible: false,
      capacityList: [],
      form: {
        slot_date: '',
        total_capacity: 5
      },
      rules: {
        slot_date: [{ required: true, message: 'Vui lòng chọn ngày mở bán', trigger: 'change' }],
        total_capacity: [{ required: true, message: 'Vui lòng nhập sức chứa', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.fetchCapacities()
  },
  methods: {
    getProductId() {
      return this.product.id || this.product._id
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      try {
        const d = new Date(dateStr)
        return d.toLocaleString('vi-VN')
      } catch (_) {
        return dateStr
      }
    },
    fetchCapacities() {
      const productId = this.getProductId()
      if (!productId) return
      this.loading = true
      getCapacities(productId).then((res) => {
        const data = res.data || res
        this.capacityList = Array.isArray(data) ? data : (data.items || data.list || [])
      }).catch(() => {
        this.capacityList = []
      }).finally(() => {
        this.loading = false
      })
    },
    openCreateDialog() {
      // Default to ISO date string format
      const isoNow = new Date().toISOString()
      this.form = {
        slot_date: isoNow,
        total_capacity: 5
      }
      this.dialogVisible = true
    },
    handleCreate() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        const productId = this.getProductId()
        this.submitting = true
        createCapacity(productId, this.form).then((res) => {
          this.$message.success('Thêm slot mở bán vé thành công!')
          this.dialogVisible = false
          this.fetchCapacities()
        }).catch((err) => {
          const errMsg = (err && err.message) ? err.message : 'Lỗi khi tạo slot bán vé'
          this.$message.error(errMsg)
        }).finally(() => {
          this.submitting = false
        })
      })
    },
    handleDelete(row) {
      this.$confirm('Bạn có chắc chắn muốn xóa slot mở bán vé này?', 'Xác nhận xóa', {
        type: 'warning'
      }).then(() => {
        const productId = this.getProductId()
        const capacityId = row.id || row._id
        deleteCapacity(productId, capacityId).then(() => {
          this.$message.success('Xóa slot bán vé thành công!')
          this.fetchCapacities()
        }).catch((err) => {
          const errMsg = (err && err.message) ? err.message : 'Không thể xóa slot bán vé'
          this.$message.error(errMsg)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.product-capacities .title {
  font-size: 16px;
}
.d-flex {
  display: flex;
}
.justify-content-between {
  justify-content: space-between;
}
.align-items-center {
  align-items: center;
}
</style>
